export const GET_PLANNINGS_REQUEST = "GET_PLANNINGS_REQUEST";
export const GET_PLANNINGS_SUCCESS = "GET_PLANNINGS_SUCCESS";
export const GET_PLANNINGS_ERROR = "GET_PLANNINGS_ERROR";
export const GET_PLANNINGS_DONE = "GET_PLANNINGS_DONE";

export const ADD_PLANNING_REQUEST = "ADD_PLANNING_REQUEST";
export const ADD_PLANNING_SUCCESS = "ADD_PLANNING_SUCCESS";
export const ADD_PLANNING_ERROR = "ADD_PLANNING_ERROR";

export const UPDATE_PLANNING_REQUEST = "UPDATE_PLANNING_REQUEST";
export const UPDATE_PLANNING_SUCCESS = "UPDATE_PLANNING_SUCCESS";
export const UPDATE_PLANNING_ERROR = "UPDATE_PLANNING_ERROR";

export const DELETE_PLANNING_REQUEST = "DELETE_PLANNING_REQUEST";
export const DELETE_PLANNING_SUCCESS = "DELETE_PLANNING_SUCCESS";
export const DELETE_PLANNING_ERROR = "DELETE_PLANNING_ERROR";
export const GET_SUBCRIPTIONSTATUS_REQUEST = "GET_SUBCRIPTIONSTATUS_REQUEST";
export const getSubcriptionStatusRequest = (payload) => ({
  type: GET_SUBCRIPTIONSTATUS_REQUEST,
  ...payload,
});

export const getPlanningsRequest = (payload) => ({
  type: GET_PLANNINGS_REQUEST,
  ...payload,
});

export const getPlanningsSuccess = (plannings) => ({
  type: GET_PLANNINGS_SUCCESS,
  plannings,
});

export const getPlanningsError = (error) => ({
  type: GET_PLANNINGS_ERROR,
  error,
});

export const getPlanningsDone = () => ({
  type: GET_PLANNINGS_DONE,
});

export const addPlanningRequest = (payload) => ({
  type: ADD_PLANNING_REQUEST,
  ...payload,
});

export const addPlanningSuccess = (planning, tempId) => ({
  type: ADD_PLANNING_SUCCESS,
  planning,
  tempId,
});

export const addPlanningError = (planning) => ({
  type: ADD_PLANNING_ERROR,
  planning,
});

export const updatePlanningRequest = (payload) => ({
  type: UPDATE_PLANNING_REQUEST,
  ...payload,
});

export const updatePlanningSuccess = (planning) => ({
  type: UPDATE_PLANNING_SUCCESS,
  planning,
});

export const updatePlanningError = (planning) => ({
  type: UPDATE_PLANNING_ERROR,
  planning,
});

export const deletePlanningRequest = (payload) => ({
  type: DELETE_PLANNING_REQUEST,
  ...payload,
});

export const deletePlanningSuccess = (planning) => ({
  type: DELETE_PLANNING_SUCCESS,
  planning,
});

export const deletePlanningError = (planning) => ({
  type: DELETE_PLANNING_ERROR,
  planning,
});



// WEBPACK FOOTER //
// ./src/pages/plannings/actions.js